import React from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";

import logo from "../../assets/images/logos/techadive_logo.svg";
import linkedInIcon from "../../assets/images/icons/linkedin.svg";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__inner">
                <div className="footer__top">
                    <div className="footer__brand">
                        <Link
                            className="footer__brand-link"
                            to="/"
                            aria-label="Techadive homepage"
                        >
                            <img
                                className="footer__logo"
                                src={logo}
                                alt="Techadive"
                            />
                        </Link>

                        <p className="footer__tagline">
                            We Build. We Connect. We Innovate.
                        </p>

                        <p className="footer__description">
                            Digital solutions, technology ventures, and connections
                            with opportunities across Africa.
                        </p>

                        <a
                            className="footer__social"
                            href="https://www.linkedin.com/company/tech-a-dive/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={linkedInIcon} alt="" width="20" height="20" />
                            LinkedIn
                            <span aria-hidden="true">↗</span>
                            <span className="footer__sr-only">
                {" "}
                                (opens in a new tab)
              </span>
                        </a>
                    </div>

                    <nav className="footer__navigation" aria-label="Footer navigation">
                        <h2 className="footer__heading">Explore</h2>

                        <ul className="footer__links">
                            <li><Link to="/">Home</Link></li>
                            <li><a href="/#what-we-build">Our Solutions</a></li>
                            <li><Link to="/invest-africa">Invest Africa</Link></li>
                            <li><a href="/#ventures">Our Ventures</a></li>
                            <li><Link to="/about">About Techadive</Link></li>
                            <li><Link to="/contact">Contact</Link></li>
                        </ul>
                    </nav>

                    <div className="footer__contact">
                        <h2 className="footer__heading">Get in Touch</h2>

                        <address>
                            <a href="mailto:info@techadive.com">
                                info@techadive.com
                            </a>

                            <a href="tel:+48791285559">
                                +48 791 285 559
                            </a>

                            <p>
                                Nairobi, Kenya
                                <br />
                                Warsaw, Poland
                            </p>
                        </address>
                    </div>

                    <div className="footer__cta-column">
                        <h2 className="footer__heading">Start a Conversation</h2>

                        <p>
                            Have a project or partnership in mind? Connect with our team.
                        </p>

                        <Link className="footer__cta" to="/contact">
                            Let’s Talk
                            <span aria-hidden="true">↗</span>
                        </Link>
                    </div>
                </div>

                <div className="footer__bottom">
                    <p>
                        © {new Date().getFullYear()} Techadive. All rights reserved.
                    </p>

                    <nav aria-label="Legal">
                        <ul className="footer__legal">
                            <li>
                                <Link to="/privacy-policy">Privacy Policy</Link>
                            </li>
                            <li>
                                <Link to="/cookies-policy">Cookies Policy</Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </footer>
    );
};

export default Footer;